import React from "react";
import type { SvgIconProps } from "@mui/material";
import {
    Speed as SpeedIcon,
    Thermostat as ThermostatIcon,
    WaterDrop as WaterDropIcon,
} from "@mui/icons-material";
import { PTI_POSITION_KEYS } from "./ptiConstants";

export const PTI_ICON_BODY_ZONES: Set<string> = new Set([
    PTI_POSITION_KEYS.Dashboard,
    PTI_POSITION_KEYS.Coolant,
    PTI_POSITION_KEYS.Oil,
]);

const ZONE_ICONS: Record<string, React.ComponentType<SvgIconProps>> = {
    [PTI_POSITION_KEYS.Dashboard]: SpeedIcon,
    [PTI_POSITION_KEYS.Coolant]: ThermostatIcon,
    [PTI_POSITION_KEYS.Oil]: WaterDropIcon,
};

export function isPtiIconBodyZone(positionKey: string): boolean {
    return PTI_ICON_BODY_ZONES.has(positionKey);
}

export function getPtiZoneIconSize(positionKey: string): number {
    return positionKey === PTI_POSITION_KEYS.Dashboard ? 18 : 14;
}

export function getPtiZoneIcon(
    positionKey: string
): React.ComponentType<SvgIconProps> | undefined {
    return ZONE_ICONS[positionKey];
}

interface PtiZoneIconProps {
    positionKey: string;
    color: string;
}

export const PtiZoneIcon: React.FC<PtiZoneIconProps> = ({ positionKey, color }) => {
    const Icon = ZONE_ICONS[positionKey];
    if (!Icon) {
        return null;
    }

    return <Icon sx={{ fontSize: getPtiZoneIconSize(positionKey), color }} />;
};
